export default "__VITE_ASSET__a36170a0__"